import services from './services';
import {
	lg,
	cloneDeep,
	util,
	isCorrectVal,
	isDate
} from 'utils';
import {
	GetProvinces,
	GetCitys,
	GetAreas,
	GetAgentList,
	GetParmConfig, //寄送，支付接口
	GetProductClass,
	GetAgentConsigneeList,
	Consignee_Add,
	GetEmployList,
	ConsigneeSetDefault
} from '@api/commonApi.js';
import NProgress from 'nprogress';
import addD55Order from '@pages/SchoolOrder/components/addD55Order/index.vue'
import D55OrderView from '@pages/SchoolOrder/components/D55OrderView/index.vue'
import schoolTableList from 'src/common/components/schoolTableList/index.vue'
import agentTableList from 'src/common/components/agentTableList/index.vue'
export default {
	mixins: [services],
	components: {
		addD55Order,
		D55OrderView,
		schoolTableList,
		agentTableList
	},
	data() {
		return {
			Session: util.getSessin(),
			//发货状态
			querySort: [{
				"SortName": "全部",
				"SortValue": "-1"
			}, {
				"SortName": "未发货",
				"SortValue": "0"
			}, {
				"SortName": "已配货",
				"SortValue": "6"
			}, {
				"SortName": "部分发货",
				"SortValue": "1"
			}, {
				"SortName": "全部发货",
				"SortValue": "2"
			}, {
				"SortName": "无需发货",
				"SortValue": "7"
			}],
			queryType: [{
				"TypeName": "全部",
				"TypeValue": "-1"
			}, {
				"TypeName": "待审核",
				"TypeValue": "1"
			}, {
				"TypeName": "财务审核通过",
				"TypeValue": "6"
			}, {
				"TypeName": "财务审核不通过",
				"TypeValue": "12"
			}, {
				"TypeName": "待内控审核",
				"TypeValue": "4"
			}, {
				"TypeName": "内控审核不通过",
				"TypeValue": "15"
			}, {
				"TypeName": "内控审核通过",
				"TypeValue": "16"
			}],

			loading: false,
			lists: [],
			pageIndex: 1,
			pageSize: 10,
			totalSize: '',
			sels: [], //列表选中列
			pageSizes: [10, 20, 50],
			query: this.getFormData()

		}
	},
	methods: {
		getFormData() {
			return cloneDeep({
				OrderCode: "",
				AgentName: "",
				SchoolName: "",
				PackageId: "",
				SendStatus: "",
				OrderStartTime: "",
				OrderEndTime: "",
				OrderStatus: "-1",
				C_Name: ""
			});
		},
		//删除订单
		handleDel(index, row) {
			this.$confirm('确认删除吗？', '提示', {}).then(() => {
				this.DelList(row.OrderId)
			})
		},
		//查看订单
		handleView(index, row) {
			this.$refs.refD55OrderView.show({
				OrderId: row.OrderId,
				title: '查看订单',
				isReadOnly: true

			})


		},
		//编辑订单
		handleEdit(index, row) {
			this.$refs.refAddD55Order.show({
				OrderId: row.OrderId,
				title: '修改订单',
				isReadOnly: false

			})
		},
		//续订资源包
		addOrder: function () {
			this.$refs.refAddD55Order.show({
				title: "新增D55/D65订单",
				isReadOnly: false,
			});
		},
		selsChange: function (sels) {
			this.sels = sels;
		},
		chooseSchool() {
			this.$refs.refschoolTableList.show({
				title: '请选择园所'
			})
		},

		getSchoolName(item) {
			this.query.SchoolName = item.SchoolName
		},
		chooseAgent() {
			this.$refs.refagentTableList.show({
				title: '请选择代理商'
			})
		},
		getAgentName(item) {
			this.query.AgentName = item.AgentName
		},
		//查询
		onQuerySubmit: function () {
			this.pageIndex = 1;
			this.getList();
		}, //查询功能
		handleSizeChange: function (val) {
			this.pageSize = val;
			this.getList()
		},
		onQueryClean: function () {
			this.query = this.getFormData();
			this.getList();
		},
		//导出功能
		download() {
			this.$confirm('确认导出吗？', '提示', {}).then(() => {
				let params = {
					Sid: this.$store.state.sysSid,
					Session: this.$store.state.sysSession
				};
				params = Object.assign({}, params, util.getFormSearchParams(this.query));
				util.exportToFileV2("api/MeetOrder/GetPushOrderByPageExport", params, this)
			});
		},
		handleCurrentChange: function (val) {
			this.pageIndex = val;
			this.getList();
		}
	},
	created() {
		this.getList();
	},

}


// WEBPACK FOOTER //
// ./src/pages/SchoolOrder/D55Order/vm.js